import snakeCaseKeys from 'snakecase-keys';
import camelcaseKeys from 'camelcase-keys';
import API from 'shared/constants/api';
import partsStatuses from 'shared/constants/json/partsStatuses.json';
import { objectsToIDs } from 'shared/helpers/common';
import { partsFormActions, partsFormAsyncSetActions } from 'shared/actions/partsForm';
import { compareByTitle } from './arrays';

export const postForm = (
  fetch,
  token,
  {
    transport,
    model,
    advertFields,
    subRubric,
    // Photos
    photos,
    photosToUpdate,
    photosToDelete,
    ...formState
  },
) =>
  fetch(API.SPARE_PARTS.ALL(), {
    headers: { Authorization: `JWT ${token}` },
    method: 'POST',
    body: JSON.stringify(
      snakeCaseKeys({
        ...objectsToIDs({
          ...formState,
          photos,
          vehicleType: transport,
        }),
        sparetypes: subRubric ? [subRubric.id] : [],
        models: model ? [model.id] : [],
        ...advertFields,
      }),
    ),
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Не удалось отправить форму. Попробуйте позже.');
      }

      return response;
    })
    .then(r => r.json());

export const patchForm = (
  fetch,
  token,
  {
    transport,
    model,
    advertFields,
    subRubric,
    // Photos
    photos,
    photosToUpdate,
    photosToDelete,
    ...formState
  },
  id,
) =>
  fetch(API.SPARE_PARTS.ITEM(id), {
    headers: { Authorization: `JWT ${token}` },
    method: 'PATCH',
    body: JSON.stringify(
      snakeCaseKeys({
        ...objectsToIDs({
          ...formState,
          photos,
          vehicleType: transport,
        }),
        sparetypes: subRubric ? [subRubric.id] : [],
        models: model ? [model.id] : [],
        ...advertFields,
      }),
    ),
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Не удалось отправить форму. Попробуйте позже.');
      }

      return response;
    })
    .then(r => r.json());

//

const fetchLocation = (fetch, id) =>
  id ? fetch(API.VOCABULARY.location(id)).then(r => r.json()) : Promise.resolve();

export const fetchLocations = fetch => fetch(API.VOCABULARY.locations()).then(r => r.json());

export const fetchAllCities = async (fetch, sort = true) => {
  let cities = [];
  try {
    const result = await fetchLocations(fetch);
    if (!result || !result[0] || result[0].id !== 1911) return [];
    const regions = result[0].children;
    cities = cities.concat(...regions.map(item => item.children));
  } catch (err) {
    console.log(err);
  }
  return sort ? cities.sort(compareByTitle) : cities;
};

export const fillUserData = async (fetch, store, shouldFetchLocation = true) => {
  const state = store.getState();
  const email = state.user.user.email || null;
  const phones = (state.user.user.phones || [])
    .filter(phone => phone.is_verified)
    .map(phone => phone.number);

  store.dispatch(partsFormActions.partsForm.selected.set.email(email));
  store.dispatch(partsFormActions.partsForm.selected.set.phones(phones));

  if (state.user.user.name) {
    store.dispatch(partsFormActions.partsForm.selected.set.contactName(state.user.user.name));
  }

  if (shouldFetchLocation) {
    const location = await (state.advertForm.selected.location ||
      fetchLocation(fetch, state.user.user.location));

    if (location) {
      store.dispatch(partsFormActions.partsForm.selected.set.location(location));
    }
  }
};

/**
 *  Initializes the partsForm from an advert and user data.
 *  If false is returned then the user doesn't have rights to edit the advert.
 *
 * @param fetch
 * @param store
 * @param thisAdvert
 * @returns {Promise<boolean>}
 */
export const loadFromAdvert = async (fetch, store, thisAdvert) => {
  const selectedActions = partsFormActions.partsForm.selected;
  const {
    vehicleType: transport,
    rubric,
    make,
    sparetypes,
    models,
    price,
    ...camelcasedAdvert
  } = camelcaseKeys(thisAdvert);
  const { user } = store.getState();

  // Check if my advert
  if (!thisAdvert.author || thisAdvert.author.id !== user.user.id) {
    return false;
  }

  await store.dispatch(partsFormAsyncSetActions.transport(transport));
  await store.dispatch(partsFormAsyncSetActions.rubric(rubric));
  await store.dispatch(partsFormAsyncSetActions.make(make));

  if (sparetypes[0]) {
    store.dispatch(selectedActions.set.subRubric(sparetypes[0]));
  }
  if (models[0]) {
    store.dispatch(selectedActions.set.model(models[0]));
  }

  Object.keys(selectedActions.set).forEach(key => {
    const value = camelcasedAdvert[key];

    if (
      (value && (typeof value !== 'object' || Array.isArray(value))) ||
      (value && (value.id || value.id === 0))
    ) {
      store.dispatch(selectedActions.set[key](value));
    }
  });

  fillUserData(fetch, store, false);
  const priceValue = price.find(
    priceObject => priceObject.currency === camelcasedAdvert.currency.slug,
  );
  store.dispatch(selectedActions.set.price((priceValue && priceValue.value) || null));

  partsStatuses.forEach(status => {
    if (thisAdvert[status.id]) {
      store.dispatch(selectedActions.toggle.advertFields(status.id));
    }
  });

  return true;
};



// WEBPACK FOOTER //
// ./src/shared/helpers/partsForm.js